import { Injectable } from '@angular/core';

@Injectable()
export class PhoneNumberService {

  constructor() { }

  getPhoneNumber(phoneNumber: string): any {
    if (phoneNumber) {
      if (phoneNumber.includes('-')) {
        return phoneNumber.split('-')[1];
      } else if (phoneNumber.startsWith('+')) {
        return phoneNumber.substr(2);
      } else {
        return phoneNumber.substr(1);
      }
    }
    return '';
  }
  getCountryCode(phoneNumber: string): any {
    if (phoneNumber) {
      if (phoneNumber.includes('-')) {
        return phoneNumber.split('-')[0];
      } else if (phoneNumber.startsWith('+')) {
        return phoneNumber.substr(0, 2);
      } else {
        return `+${phoneNumber.substr(0, 1)}`;
      }
    }
    return '+1';
  }

  /**
   * Combines a country code and a national number into E.164 (e.g. +14145550100), or returns
   * null when they do not make a valid one. Formatting characters are ignored; a +1 number must
   * have exactly ten digits.
   */
  toE164(countryCode: string, phoneNumber: string): string | null {
    const country = (countryCode ?? '').replace(/\D+/g, '');
    const national = (phoneNumber ?? '').replace(/\D+/g, '');
    if (!country || !national) {
      return null;
    }
    if (country === '1' && national.length !== 10) {
      return null;
    }
    const e164 = `+${country}${national}`;
    return /^\+[1-9]\d{7,14}$/.test(e164) ? e164 : null;
  }

  formatPhoneNumber(phoneNumber: string, countryCode: string): any {
    if (phoneNumber) {
      if (countryCode === '+1' && phoneNumber.length >= 10) {
        const areaCode = phoneNumber.substr(0, 3);
        const firstPart = phoneNumber.substr(3, 3);
        const rest = phoneNumber.substr(6);

        let formated = `(${areaCode}) `;

        if (firstPart) {
          formated += firstPart;
        }

        if (rest) {
          formated += `-${rest}`;
        }

        return formated;
      } else {
        return phoneNumber;
      }
    } else {
      return phoneNumber;
    }
  }
}
